<template>
  <AppLayout>
    <template #middle>
      <ProfileContent />
    </template>
    <template #outside>
      <ProfileDescriptionModal />
      <ProfilePictureModal />
      <MfaSetupModal />
      <MfaDisableModal />
      <ProgramCriteriasModal />
    </template>
  </AppLayout>
</template>
<script setup lang="ts">
import AppLayout from '@/(routes)/(protected)/(app)/layout.vue'
import MfaDisableModal from '@/features/auth/components/mfa-disable-modal/mfa-disable-modal.vue'
import MfaSetupModal from '@/features/auth/components/mfa-setup-modal/mfa-setup-modal.vue'
import ProfileDescriptionModal from '@/features/auth/components/profile-description-modal/profile-description-modal.vue'
import ProfilePictureModal from '@/features/auth/components/profile-picture-modal/profile-picture-modal.vue'
import ProfileContent from '@/features/ui/pages/profile/profile-content/profile-content.vue'
import ProgramCriteriasModal from '@/features/ui/pages/dashboard/dashboard-content/mentor/program-criterias-modal/program-criterias-modal.vue'
</script>
